<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.solicitantes"
            sort-by="infraestruturaNome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$refs.ModalRegulador.open(item)"
                    color="info"
                    small
                    title="Reguladores"
                >
                    <rkm-icon icon="building" />
                </rkm-button>

                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="item.reguladores.some(r => r.hasSolicitacao)"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />

        <ModalRegulador
            :data="data"
            ref="ModalRegulador"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'
import ModalRegulador from './components/regulador/Modal'

export default {
    components: { Modal, ModalRegulador },
    data: () => ({
        fields: [
            { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true },
            { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
            { key: 'isPpi', label: 'PPI', formatter: value => value ? 'SIM' : 'NÃO' },
            { key: 'atendeOutroMunicipio', label: 'Atende outro município', formatter: value => value ? 'SIM' : 'NÃO', class: 'col-min' },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(solicitante) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o solicitante?',
                async () => this.data.model.solicitantes.splice(this.data.model.solicitantes.indexOf(solicitante), 1)
            )
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>